module.exports = __webpack_public_path__ + "img/FIA_plavi_znak.3eda9737.png";